import React, { useEffect } from 'react';
import { readDrillToken, recordDrillView } from '../utils/drillTelemetry';
import './drill-1.css';

/**
 * Internal phishing-drill debrief. German only. No marketing chrome, no login form.
 * Title and robots are applied by DocumentHead.
 */
const DrillPage: React.FC = () => {
  useEffect(() => {
    recordDrillView(readDrillToken(window.location.search));
  }, []);

  return (
    <div className="drill-1" lang="de">
      <div className="drill-1-tape" aria-hidden="true" />
      <article className="drill-1-wrap">
        <p className="drill-1-kicker">
          <span className="drill-1-stamp">Simulation</span>
          <span>TamerinTECH · interne Sicherheitsübung</span>
        </p>
        <h1>Das war eine autorisierte Phishing-Übung</h1>
        <img
          className="drill-1-gif"
          src="/drill-1/gotcha.gif"
          alt="Mann vor einer Explosion, der mit erhobenen Händen so tut, als sei nichts gewesen."
        />
        <p className="drill-1-caption">…Nichts zu sehen, bitte weitergehen 🙂</p>
        <p>
          Du hast auf einen Link in einer gefälschten Anthropic-Mail geklickt. Die Mail hat das
          interne Technik-Team der TamerinTECH als Sicherheitsübung verschickt. Es gab kein
          Login-Formular, und es wurden keine Zugangsdaten abgefragt.
        </p>
        <p>
          Ob die Mail geöffnet und ob der Link angeklickt wurde, speichern wir über ein zufälliges
          Token — damit wir die Übung auswerten können, nicht um dich bloßzustellen. In einer echten
          Attacke hätte genau dieser Klick zu einer Seite führen können, die Passwort, API-Key oder
          Sitzung abgreift.
        </p>

        <h2>Die Warnzeichen in dieser Mail</h2>
        <ol>
          <li>
            <strong>Absendername und Adresse passen nicht zusammen.</strong> Sichtbar stand
            „Anthropic Konto-Sicherheit“, die echte Adresse war aber eine TamerinTECH-Adresse
            (@tamerin.tech), nicht @anthropic.com. Anthropic schreibt nicht von unserer Domain —
            und wir schreiben nicht in Anthropics Namen, außer in genau so einer Übung.
          </li>
          <li>
            <strong>Sperrung, letzte Warnung, 24 Stunden.</strong> Angst und Frist sollen dich am
            Nachdenken hindern. Echte Konto-Sicherheit bei Anthropic läuft über claude.ai oder
            console.anthropic.com, die du selbst öffnest — nicht über einen Button in einer Mail.
          </li>
          <li>
            <strong>Der Link führte auf tamerin.tech</strong>, nicht auf anthropic.com. Vor dem
            Klick die Zieladresse ansehen (Mauszeiger darauf halten oder auf dem Handy lange
            drücken).
          </li>
          <li>
            <strong>Kein zweiter Kanal.</strong> Niemand bei Anthropic und niemand bei uns bittet
            dich per Mail, ein Konto zu „bestätigen“, ohne dass das vorher intern angekündigt
            wurde. Im Zweifel Ron auf einem anderen Kanal fragen (Chat, Anruf) — nicht auf die Mail
            antworten.
          </li>
          <li>
            <strong>Eine echte Absenderdomain ist kein Beweis.</strong> Die Mail kam über unseren
            eigenen Mailversand und kann SPF/DKIM bestehen. Genau so arbeiten Angreifer, wenn sie
            einmal Zugang zu einem Postfach oder SMTP-Konto haben.
          </li>
        </ol>

        <h2>Nächstes Mal</h2>
        <div className="drill-1-next">
          <p>
            Nicht klicken. Anthropic/Claude über dein eigenes Lesezeichen oder durch Eintippen der
            Adresse öffnen. Geht es um <strong>Geld, Passwort oder Zugang</strong>, erst auf einem
            zweiten Kanal nachfragen. Verdächtige Mails an{' '}
            <a href="mailto:ron@tamerin.tech">ron@tamerin.tech</a> weiterleiten. Eine verdächtige
            Mail zu melden ist der Gewinn — auch wenn sie sich hinterher als echt herausstellt.
          </p>
        </div>
        <p>
          Bitte sprich mit niemandem im Team über diese Mail, bis Ron die Auswertung macht. So
          bleibt die Übung für alle gleich. In den Ergebnissen stehen Tokens, keine Namen.
        </p>
        <p>Fragen? An Ron.</p>
        <p className="drill-1-foot">
          TamerinTECH GmbH · interne Übung, kein öffentliches Angebot · diese Seite ist nicht für
          Suchmaschinen bestimmt
        </p>
      </article>
      <div className="drill-1-tape" aria-hidden="true" />
    </div>
  );
};

export default DrillPage;
